module.exports = __webpack_public_path__ + "static/a-xx-035-art-368d98cffc167735d05ef9b7dcf1fb31.jpg";